import ProfileApi from 'Api/profile';

export const PROFILE_AUTOCOMPLETE_REQUEST = 'PROFILE_AUTOCOMPLETE_REQUEST';
export const PROFILE_AUTOCOMPLETE_SUCCESS = 'PROFILE_AUTOCOMPLETE_SUCCESS';
export const PROFILE_AUTOCOMPLETE_ERROR = 'PROFILE_AUTOCOMPLETE_ERROR';

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function loadAutocomplete(filter = {}) {
    const { page } = filter;
    return {
        requestType: 'PROFILE_AUTOCOMPLETE',
        request: ProfileApi.find({ ...filter, page: page || 1 }),
    };
}



// WEBPACK FOOTER //
// ./src/actions/profile.js